import 'reflect-metadata';
import symbolObservable from 'symbol-observable';

if (typeof Symbol === 'function' && !Symbol.observable) {
  Symbol.observable = symbolObservable;
}
